import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { SymbolSearchService } from '@app/_shared';

@Injectable({
  providedIn: 'root'
})
export class SymbolInfoResolve  {
  constructor(private symbolSearchService: SymbolSearchService) { }

  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    return this.symbolSearchService.isDataLoaded();
  }
}
